<template>
    <div class="setting-component">
        <el-tabs v-model="type" @tab-click="handleClick">
          <el-tab-pane name="engagement" label="Engagements">
              
          </el-tab-pane>
          <el-tab-pane name="project" label="Projects">
              
          </el-tab-pane>
        </el-tabs>

        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                  <!-- <el-select v-model="type" placeholder="" size="mini" filterable style="margin-right: 20px;" @change="changeType()">
                    <el-option v-for="item in typeList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select> -->
                  
                  <el-button v-if="companyLayout" :disabled="!companyLayout.permission.createRegions" @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_regions_add')}} {{btnText}}</el-button>
                </div>
                <el-table
                        max-height="650"
                        :data="tableData"
                        :empty-text="$t('general_noData')"
                        style="width: 100%">
                    <el-table-column
                      label="ID"
                      type="index"
                      width="50">
                    </el-table-column>
                    <el-table-column
                            prop="code"
                            :label="$t('settings_regions_code')"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            :label="$t('settings_regions_name')">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            :label="$t('settings_regions_operations')">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    v-if="companyLayout"
                                    :disabled="!companyLayout.permission.updateRegions"
                                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    icon="el-icon-delete"
                                    v-if="companyLayout"
                                    :disabled="!companyLayout.permission.deleteRegions"
                                    @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- add -->
        <sweet-modal blocking :title="`${$t('settings_regions_add')} ${btnText}`" ref="openModal" class="modal" v-on:close="closeModal">

            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name">
                      <el-input :label="paleceholderText + ` ${$t('settings_regions_name')}`" v-model="form.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="code">
                      <el-input :label="paleceholderText + ` ${$t('settings_regions_code')}`" v-model="form.code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!-- edit -->
        <sweet-modal blocking :title="`${$t('settings_regions_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">

            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name">
                      <el-input :label="paleceholderText + ` ${$t('settings_regions_name')}`" v-model="formEdit.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="code">
                      <el-input :label="paleceholderText + ` ${$t('settings_regions_code')}`" v-model="formEdit.code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    components: {
      // Header,
      // Menu,
      SweetModal,

    },
    beforeCreate() {},
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    data() {
      return {
        type: 'engagement',
        typeList: [{id: 1, label: 'Project', value: 'project'}, {id: 2, label: 'Engagement', value: 'engagement'}],
        paleceholderText: this.$i18n.t('settings_regions'),
        btnText:this.$i18n.t('settings_regions'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        serviceIndex: null,
        form:{
          name: '',
          code: ''
        },
        formEdit:{
          name: '',
          code: ''
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      handleClick(tab, event) {
        if(tab.name === 'project'){
          this.changeType()
        }
        if(tab.name === 'engagement'){
          this.changeType()
        }
      },
      changeType() {
        this.loadList()
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/regions/list?companyId=${this.$route.query.companyId}&type=${this.type}`)
            .then(response => {
                this.tableData = response.data.list
                loader.hide()
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/regions/create`, {
                companyId: this.$route.query.companyId,
                name: this.form.name,
                code: this.form.code,
                type: this.type
              })
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      openModalAdd(){
        this.$refs.openModal.open()
      },
      closeModal(){
        this.form.name = ''
        this.form.code = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.formEdit.code = ''
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(index, row) {
        console.log(row)
        this.selectedRowId = row.id

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/regions/item?regionId=${row.id}&type=${this.type}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            this.formEdit.code = response.data.item.code
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/regions/update?companyId=${this.$route.query.companyId}&regionId=${this.selectedRowId}&type=${this.type}`, this.formEdit)
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        this.selectedRowId = row.id

        this.$confirm(this.$t('settings_regions_ThisWillPermanentlyDeleteTheTemplatesContinue'), this.$t('settings_regions_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('general_deleteCompleted')
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/regions/delete?companyId=${this.$route.query.companyId}&regionId=${this.selectedRowId}&type=${this.type}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    // watch:{
    //   tableData(val){
    //     val.forEach(i =>{
    //       i.createDate = moment(i.createDate.toString(), 'X').format('DD MMMM YYYY')
    //     })
    //   }
    // }
  }
</script>

<style lang="scss" scoped>
  .setting-component{
    min-width:810px;
  }
</style>
